import React from "react";

import { graphql } from "gatsby";

import Campaign from "../../components/campaigns/campaign";
import { DisplayDate } from "../../utils/dateHelper";
import backgroundImageHelper from "../image/backgroundImageHelper";

interface CampaignCardProps {
  data: Queries.kontent_item_article_page_campaign[];
  small?: boolean;
  tile?: boolean;
  author?: string | null;
  className?: string;
}

const CampaignCard: React.FC<CampaignCardProps> = ({
  data,
  small = false,
  tile = false,
  author = null,
  className = undefined,
}) => {
  const campaigns: React.ReactElement[] = [];

  let campaignData: Queries.kontent_item_article_page_campaign[] = data;

  if (author) {
    campaignData = data.filter((item) => (
      (item.elements?.author_name?.value?.length ?? 0) > 0 && item.elements?.author_name?.value?.[0]?.codename === author));
  }

  campaignData.forEach((campaign) => {
    campaigns.push(
      <Campaign
        className={className}
        backgroundImageStyle={backgroundImageHelper(
          campaign.elements?.hero_image?.value?.[0] as Queries.kontent_item_image,
          { w: 1000 },
        )}
        date={DisplayDate(
          campaign.elements?.publishdate?.value || "",
          campaign.elements?.publishdate?.display_timezone,
        )}
        href={campaign.id}
        key={campaign.id}
        small={small}
        tile={tile}
      >
        {campaign.elements?.hero_headline?.value}
      </Campaign>,
    );
  });

  return React.Children.toArray(campaigns);
};

export const query = graphql`
  fragment CampaignCard on kontent_item_article_page_campaign {
    id
    system {
      codename
    }
    elements {
      author_name {
        value {
          codename
        }
      }
      hero_headline {
        value
      }
      hero_image {
        value {
          ...KontentItemImage
          ...KontentItemVideo
        }
      }
      publishdate {
        display_timezone
        value
      }
    }
  }
`;

export default CampaignCard;
